import { ProjectPageContainer } from 'domains/projects/screens/ProjectPage';
import { ProjectsPageContainer } from 'domains/projects/screens/ProjectsPage';
import { useLegacyProjectIdRedirect } from 'domains/projects/hooks/useLegacyProjectIdRedirect';

import { projectsRoutesConfig } from '../../const';

const { useParams } = projectsRoutesConfig.project;

export const ProjectsParamsResolver = () => {
  const { legacyProjectId, projectIndex } = useParams();

  useLegacyProjectIdRedirect();

  if (projectIndex !== undefined || legacyProjectId) {
    return <ProjectPageContainer />;
  }

  return <ProjectsPageContainer />;
};
